// Simple logger utility for debugging
const logger = {
  log: (component, message, data = null) => {
    const timestamp = new Date().toISOString();
    const logMessage = `[${timestamp}] [${component}] ${message}`;
    
    if (data) {
      console.log(logMessage, data);
    } else {
      console.log(logMessage);
    }
  },
  
  error: (component, message, error = null) => {
    const timestamp = new Date().toISOString();
    const logMessage = `[${timestamp}] [ERROR] [${component}] ${message}`;
    
    if (error) {
      console.error(logMessage, error);
    } else {
      console.error(logMessage);
    }
  },
  
  warn: (component, message, data = null) => {
    const timestamp = new Date().toISOString();
    const logMessage = `[${timestamp}] [WARN] [${component}] ${message}`;
    
    if (data) {
      console.warn(logMessage, data);
    } else {
      console.warn(logMessage);
    }
  }
};

export default logger;